// antd theme: радиус, сүүдэр, хэлбэр. Өнгөний token-уудыг (primary, border, link г.м) antd-ийн
// анхных хэвээр үлдээсэн — зориуд өнгө тохируулаагүй.
export const RADIUS = { base: 8, sm: 6, lg: 12 };

export const SHADOW = {
    soft: "0 1px 2px rgba(15, 23, 42, 0.06), 0 1px 3px rgba(15, 23, 42, 0.08)",
    overlay: "0 10px 30px -8px rgba(15, 23, 42, 0.18), 0 4px 10px -4px rgba(15, 23, 42, 0.08)",
};

export const BASE_TOKENS = {
    fontSize: 13,
    borderRadius: RADIUS.base,
    borderRadiusSM: RADIUS.sm,
    borderRadiusLG: RADIUS.lg,
    boxShadow: SHADOW.overlay,
    boxShadowSecondary: SHADOW.overlay,
    colorBgContainerDisabled: "#e6edcf",
};

export const COMPONENT_TOKENS = {
    Tabs: {
        fontSize: 13,
    },
    Button: {
        fontSize: 13,
        fontSizeLG: 13,
        fontWeight: 500,
        primaryShadow: "none",
        defaultShadow: "none",
        dangerShadow: "none",
    },
    Table: {
        fontSize: 12,
    },
    Input: {
        fontSize: 13,
        colorTextDisabled: "#333",
        paddingBlock: 3,
    },
    InputNumber: {
        colorTextDisabled: "#333",
    },
    DatePicker: {
        colorTextDisabled: "#333",
    },
    Space: {
        colorBorder: "black",
    },
    Select: {
        colorTextDisabled: "#333",
    },
    Tag: {
        borderRadiusSM: 999,
    },
    Modal: {
        borderRadiusLG: RADIUS.lg + 4,
        titleFontSize: 15,
    },
    Drawer: {
        borderRadiusLG: RADIUS.lg + 4,
    },
    Dropdown: {
        borderRadiusLG: RADIUS.lg,
        paddingBlock: 6,
    },
    Menu: {
        itemBorderRadius: RADIUS.sm + 2,
        dropdownWidth: 200,
    },
    Popover: {
        borderRadiusLG: RADIUS.lg,
    },
    Popconfirm: {
        borderRadiusLG: RADIUS.lg,
    },
    Tooltip: {
        borderRadius: RADIUS.sm,
    },
    Message: {
        borderRadiusLG: 999,
        contentPadding: "8px 16px",
    },
    Notification: {
        borderRadiusLG: RADIUS.lg,
    },
};

// react-hot-toast: өмнөх төрөл бүрийн өнгөтэй дэвсгэрийг сэргээсэн, зөвхөн хэлбэр (radius, shadow) шинэ.
const TOAST_SHAPE = {
    borderRadius: 14,
    padding: "10px 14px",
    fontSize: 13,
    boxShadow: SHADOW.overlay,
};

export const TOAST_OPTIONS = {
    className: "",
    duration: 5000,
    style: { ...TOAST_SHAPE, background: "#FFF", color: "#363636" },
    success: {
        icon: "👏",
        duration: 5000,
        theme: { primary: "green", secondary: "black" },
        style: { ...TOAST_SHAPE, background: "#72c772", color: "#FFF" },
    },
    error: {
        icon: "🤔",
        duration: 5000,
        style: { ...TOAST_SHAPE, background: "#fd5050", color: "#FFF" },
        theme: { primary: "red", secondary: "black" },
    },
    warning: {
        icon: "⚠️",
        duration: 5000,
        style: { ...TOAST_SHAPE, background: "#ffae42", color: "#FFF" },
    },
    info: {
        icon: "💡",
        duration: 5000,
        style: { ...TOAST_SHAPE, background: "#3b82f6", color: "#FFF" },
    },
};
